var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-layout',{class:_vm.$s.LayoutContainer,attrs:{"has-layers":true}},[_c('div',[_c('o-layout-header',{class:_vm.$s.header},[_c('weebly-logomark')],1)],1),_c('nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }